var _circle, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg08(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#AEA09D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_391_462",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 13,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 13,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_391_462)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29 26.5C29.4333 26.5 29.7917 26.3583 30.075 26.075C30.3583 25.7917 30.5 25.4333 30.5 25C30.5 24.5667 30.3583 24.2083 30.075 23.925C29.7917 23.6417 29.4333 23.5 29 23.5C28.5667 23.5 28.2083 23.6417 27.925 23.925C27.6417 24.2083 27.5 24.5667 27.5 25C27.5 25.4333 27.6417 25.7917 27.925 26.075C28.2083 26.3583 28.5667 26.5 29 26.5ZM26 30C25.45 30 24.9793 29.8043 24.588 29.413C24.196 29.021 24 28.55 24 28V22C24 21.45 24.196 20.979 24.588 20.587C24.9793 20.1957 25.45 20 26 20H33C33.55 20 34.021 20.1957 34.413 20.587C34.8043 20.979 35 21.45 35 22V28C35 28.55 34.8043 29.021 34.413 29.413C34.021 29.8043 33.55 30 33 30H26ZM18 34C17.45 34 16.979 33.8043 16.587 33.413C16.1957 33.021 16 32.55 16 32V18C16 17.45 16.1957 16.979 16.587 16.587C16.979 16.1957 17.45 16 18 16H32C32.55 16 33.021 16.1957 33.413 16.587C33.8043 16.979 34 17.45 34 18H26C24.8167 18 23.8543 18.3707 23.113 19.112C22.371 19.854 22 20.8167 22 22V28C22 29.1833 22.371 30.1457 23.113 30.887C23.8543 31.629 24.8167 32 26 32H34C34 32.55 33.8043 33.021 33.413 33.413C33.021 33.8043 32.55 34 32 34H18Z",
    fill: "#AEA09D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg08);
export default __webpack_public_path__ + "static/media/08.1da6cc260289b4248666986c488dbf5e.svg";
export { ForwardRef as ReactComponent };